import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import React from 'react';

export interface LanguageOption {
  name: string;
  flag: string;
  isAccent?: boolean;
  /** Voice style pages (funny, scary, ...) — filtered via Voice.styles */
  isStyle?: boolean;
  slug?: string;
}

export const languages: LanguageOption[] = [
  { name: 'English', flag: '🇬🇧', isAccent: false },
  { name: 'Chinese', flag: '🇨🇳' },
  { name: 'Spanish', flag: '🇪🇸' },
  { name: 'Hindi', flag: '🇮🇳' },
  { name: 'Portuguese', flag: '🇵🇹' },
  { name: 'French', flag: '🇫🇷' },
  { name: 'German', flag: '🇩🇪' },
  { name: 'Japanese', flag: '🇯🇵' },
  { name: 'Arabic', flag: '🇸🇦' },
  { name: 'Korean', flag: '🇰🇷' },
  { name: 'Indonesian', flag: '🇮🇩' },
  { name: 'Italian', flag: '🇮🇹' },
  { name: 'Dutch', flag: '🇳🇱' },
  { name: 'Turkish', flag: '🇹🇷' },
  { name: 'Polish', flag: '🇵🇱' },
  { name: 'Swedish', flag: '🇸🇪' },
  { name: 'Swiss', flag: '🇨🇭', isAccent: true },
  { name: 'Filipino', flag: '🇵🇭' },
  { name: 'Malay', flag: '🇲🇾' },
  { name: 'Romanian', flag: '🇷🇴' },
  { name: 'Ukrainian', flag: '🇺🇦' },
  { name: 'Greek', flag: '🇬🇷' },
  { name: 'Czech', flag: '🇨🇿' },
  { name: 'Danish', flag: '🇩🇰' },
  { name: 'Norwegian', flag: '🇳🇴' },
  { name: 'Finnish', flag: '🇫🇮' },
  { name: 'Bulgarian', flag: '🇧🇬' },
  { name: 'Croatian', flag: '🇭🇷' },
  { name: 'Hungarian', flag: '🇭🇺' },
  { name: 'Slovak', flag: '🇸🇰' },
  { name: 'Russian', flag: '🇷🇺' },
  { name: 'Tamil', flag: '🇮🇳' },
  { name: 'Bosnian', flag: '🇧🇦' },
  { name: 'Serbian', flag: '🇷🇸' },
  { name: 'Vietnamese', flag: '🇻🇳' },
  { name: 'Persian (Farsi)', flag: '🇮🇷', slug: 'persian' },
  { name: 'Urdu', flag: '🇵🇰' },
  { name: 'Bengali', flag: '🇧🇩' },
  { name: 'Telugu', flag: '🇮🇳' },
  { name: 'Punjabi', flag: '🇮🇳' },
  { name: 'Marathi', flag: '🇮🇳' },
  { name: 'Malayalam', flag: '🇮🇳' },
  { name: 'Kannada', flag: '🇮🇳' },
  { name: 'Gujarati', flag: '🇮🇳' },
  { name: 'Kazakh', flag: '🇰🇿' },
  { name: 'Azerbaijani', flag: '🇦🇿' },
  { name: 'Afrikaans', flag: '🇿🇦' },
  { name: 'Hebrew', flag: '🇮🇱' },
  { name: 'Thai', flag: '🇹🇭' },
  { name: 'Armenian', flag: '🇦🇲' },
  { name: 'Georgian', flag: '🇬🇪' },
  { name: 'Nepali', flag: '🇳🇵' },
  { name: 'Swahili', flag: '🇰🇪' },
  { name: 'Somali', flag: '🇸🇴' },
  { name: 'Gaelic', flag: '🇮🇪' },
  { name: 'Pashto', flag: '🇦🇫' },
  { name: 'Estonian', flag: '🇪🇪' },
  { name: 'Lithuanian', flag: '🇱🇹' },
  { name: 'Slovenian', flag: '🇸🇮' },
  { name: 'Icelandic', flag: '🇮🇸' },
  { name: 'Catalan', flag: '🏴' },
  { name: 'Belarusian', flag: '🇧🇾' },
  { name: 'Latvian', flag: '🇱🇻' },
  { name: 'Macedonian', flag: '🇲🇰' },
  { name: 'Cebuano', flag: '🇵🇭' },
  { name: 'Javanese', flag: '🇮🇩' },
  { name: 'Kyrgyz', flag: '🇰🇬' },
  { name: 'Lingala', flag: '🇨🇩' },
  { name: 'Luxembourgish', flag: '🇱🇺' },
  { name: 'Galician', flag: '🇪🇸' },
  { name: 'Chichewa', flag: '🇲🇼' },
  { name: 'Assamese', flag: '🇮🇳' },
  { name: 'Sindhi', flag: '🇵🇰' },
  { name: 'Irish', flag: '🇮🇪', isAccent: true },
  { name: 'Scottish', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿', isAccent: true },
  { name: 'British', flag: '🇬🇧', isAccent: true },
  { name: 'Welsh', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿', isAccent: true },
  { name: 'Australian', flag: '🇦🇺', isAccent: true },
  { name: 'New Zealand', flag: '🇳🇿', isAccent: true },
  { name: 'Southern', flag: '🇺🇸', isAccent: true },
  { name: 'Jamaican', flag: '🇯🇲', isAccent: true },
  { name: 'Indian', flag: '🇮🇳', isAccent: true },
  { name: 'Flemish', flag: '🇧🇪', isAccent: true },
  { name: 'Essex', flag: '🇬🇧', isAccent: true },
  { name: 'Canadian', flag: '🇨🇦', isAccent: true },
  { name: 'Singaporean', flag: '🇸🇬', isAccent: true },
  { name: 'American', flag: '🇺🇸', isAccent: true },
  { name: 'Mexican', flag: '🇲🇽', isAccent: true },
  { name: 'Dutch', flag: '🇳🇱', isAccent: true, slug: 'dutch-accent' },
  { name: 'French', flag: '🇫🇷', isAccent: true, slug: 'french-accent' },
  { name: 'Austrian', flag: '🇦🇹', isAccent: true },
  { name: 'German', flag: '🇩🇪', isAccent: true, slug: 'german-accent' },
  { name: 'Russian', flag: '🇷🇺', isAccent: true, slug: 'russian-accent' },
  { name: 'Indian', flag: '🇮🇳', isAccent: true, slug: 'indian-accent' },
  { name: 'Japanese', flag: '🇯🇵', isAccent: true, slug: 'japanese-accent' },
  { name: 'Korean', flag: '🇰🇷', isAccent: true, slug: 'korean-accent' },
  { name: 'Italian', flag: '🇮🇹', isAccent: true, slug: 'italian-accent' },
  { name: 'Spanish', flag: '🇪🇸', isAccent: true, slug: 'spanish-accent' },
  { name: 'Brazilian', flag: '🇧🇷', isAccent: true },
  { name: 'Portugal', flag: '🇵🇹', isAccent: true },
  { name: 'Serbian', flag: '🇷🇸', isAccent: true, slug: 'serbian-accent' },
  { name: 'South African', flag: '🇿🇦', isAccent: true },
  { name: 'African-American', flag: '🇺🇸', isAccent: true },
  { name: 'New York', flag: '🇺🇸', isAccent: true },
  { name: 'Boston', flag: '🇺🇸', isAccent: true },
  { name: 'Brooklyn', flag: '🇺🇸', isAccent: true },
  { name: 'Texas', flag: '🇺🇸', isAccent: true },
  { name: 'Midwestern', flag: '🇺🇸', isAccent: true },
  { name: 'Posh British', flag: '🇬🇧', isAccent: true },
  { name: 'Northern Vietnamese', flag: '🇻🇳', isAccent: true },
  { name: 'Quebec', flag: '🇨🇦', isAccent: true },
  { name: 'Egyptian', flag: '🇪🇬', isAccent: true },
  { name: 'Saudi', flag: '🇸🇦', isAccent: true },
  { name: 'Levantine', flag: '🇱🇧', isAccent: true },
  { name: 'Gulf', flag: '🇦🇪', isAccent: true },
  { name: 'Moroccan', flag: '🇲🇦', isAccent: true },
  { name: 'Colombian', flag: '🇨🇴', isAccent: true },
  { name: 'Latin American', flag: '🌎', isAccent: true },
  { name: 'Castilian', flag: '🇪🇸', isAccent: true },
  // { name: 'New Orleans', flag: '🇺🇸', isAccent: true },
  { name: 'New Jersey', flag: '🇺🇸', isAccent: true },
  { name: 'Cockney', flag: '🇬🇧', isAccent: true },
  { name: 'Scouse', flag: '🇬🇧', isAccent: true },
  { name: 'Geordie', flag: '🇬🇧', isAccent: true },
  // { name: 'Birmingham', flag: '🇬🇧', isAccent: true },
  // arabic accent
  { name: 'Arabic', flag: '🇸🇦', isAccent: true, slug: 'arabic-accent' },
  { name: 'Nigerian', flag: '🇳🇬', isAccent: true },
  { name: 'Cantonese', flag: '🇨🇳', isAccent: true },
  { name: 'Mandarin', flag: '🇨🇳', isAccent: true },
  // Voice style pages (SEO): filtered via Voice.styles
  { name: 'Robot', flag: '🤖', isStyle: true },
  { name: 'Funny', flag: '😂', isStyle: true },
  { name: 'Scary', flag: '👻', isStyle: true },
  { name: 'Creepy', flag: '🕷️', isStyle: true },
  { name: 'Angry', flag: '😠', isStyle: true },
  { name: 'Cartoon', flag: '🤪', isStyle: true },
  { name: 'Anime', flag: '🎌', isStyle: true },
  { name: 'Evil', flag: '😈', isStyle: true },
  { name: 'Whisper', flag: '🤫', isStyle: true },
  { name: 'Santa', flag: '🎅', isStyle: true },
  { name: 'Deep', flag: '🎙️', isStyle: true },
  { name: 'Female', flag: '👩', isStyle: true },
  { name: 'Male', flag: '👨', isStyle: true },
  { name: 'TikTok', flag: '🎵', isStyle: true },
  { name: 'Voicemail Greeting', flag: '📞', isStyle: true },
  { name: 'Announcer', flag: '📣', isStyle: true },
  { name: 'Elderly', flag: '🧓', isStyle: true },
];

const TextToSpeechLanguages = () => {
  const { t } = useLocale('text-to-speech');

  // Split languages, accents and voice styles
  const actualLanguages = languages.filter(
    (lang) => !lang.isAccent && !lang.isStyle,
  );
  const accents = languages.filter((lang) => lang.isAccent);
  const styles = languages.filter((lang) => lang.isStyle);

  const renderLanguageGrid = (items: LanguageOption[]) => (
    <div className='grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5'>
      {items.map((language, index) => (
        <Link
          key={index}
          href={`/text-to-speech/${
            language.slug || language.name.toLowerCase().replace(' ', '-')
          }`}
          className='group flex items-center gap-3 rounded-2xl bg-white dark:bg-slate-800/80 p-4 shadow-sm ring-1 ring-gray-900/5 dark:ring-white/10 hover:-translate-y-1 hover:shadow-md hover:ring-primary-500/30 dark:hover:ring-primary-500/50 transition-all duration-200'
        >
          <span className='text-3xl filter drop-shadow-sm group-hover:scale-110 transition-transform duration-200'>
            {language.flag}
          </span>
          <span className='min-w-0 break-words font-semibold text-gray-900 [hyphens:auto] dark:text-slate-200'>
            {t(language.name)}
          </span>
        </Link>
      ))}
    </div>
  );

  return (
    <div className='bg-white dark:bg-slate-900'>
      <div className='mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24'>
        {/* Languages Section */}
        <div className='mb-16'>
          <div className='text-center mb-12'>
            <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
              {t('Supported Languages')}
            </h2>
            <p className='mt-4 text-lg text-gray-500 dark:text-slate-400 max-w-3xl mx-auto'>
              {t(
                'Our text to speech tool supports 70+ languages. Select your preferred language to generate natural-sounding speech.',
              )}
            </p>
          </div>
          <div className='flex justify-center'>
            {renderLanguageGrid(actualLanguages)}
          </div>
        </div>

        {/* Accents Section */}
        <div>
          <div className='text-center mb-12'>
            <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
              {t('Supported Accents')}
            </h2>
            <p className='mt-4 text-lg text-gray-500 dark:text-slate-400 max-w-3xl mx-auto'>
              {t(
                'Choose from diverse accents to add authentic regional flavor to your text-to-speech output.',
              )}
            </p>
          </div>
          <div className='flex justify-center'>
            {renderLanguageGrid(accents)}
          </div>
        </div>

        {/* Voice Styles Section */}
        <div className='mt-16'>
          <div className='text-center mb-12'>
            <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200'>
              {t('Voice Styles')}
            </h2>
            <p className='mt-4 text-lg text-gray-500 dark:text-slate-400 max-w-3xl mx-auto'>
              {t(
                'From funny cartoon characters to scary villains — pick a voice style and bring your script to life.',
              )}
            </p>
          </div>
          <div className='flex justify-center'>
            {renderLanguageGrid(styles)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextToSpeechLanguages;
